import { type PropsWithChildren, forwardRef } from "react";

import type { PaginationButtonProps } from "./PaginationButton.types";
import { cn } from "$/lib/utils/functions/misc.functions";

const basePaginationButtonClassName =
  "grid aspect-square w-10 h-10 cursor-pointer place-items-center rounded border border-tertiary text-base text-black font-semibold";

const PaginationButton = forwardRef<
  HTMLButtonElement,
  PropsWithChildren<PaginationButtonProps>
>(
  (
    {
      buttonType,
      pageNumber,
      isFilled = true,
      currentPage,
      children,
      ...paginationButtonProps
    },
    forwardedRef,
  ) => {
    const isCurrentPage = currentPage === pageNumber;

    return (
      <button
        ref={forwardedRef}
        type="button"
        className={cn(
          basePaginationButtonClassName,
          "text-secondary",
          {
            "cursor-default border-secondary bg-primary-300 font-semibold":
              isCurrentPage && buttonType === "page",
            "border-0 bg-transparent": !isFilled,
          },
          "disabled:bg-disable disabled:cursor-not-allowed disabled:opacity-30",
        )}
        {...paginationButtonProps}
      >
        {children}
      </button>
    );
  },
);

PaginationButton.displayName = "PaginationButton";

export default PaginationButton;
